import template from "./../templates/finito-bao-badge2.html";
import "./../content/bao-badge.css";
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
// window.baorequire css
export class FinitoBaoBadge2 {
    ReadOnly = ko.observable(false);
    ShowAll = ko.observable(false);
    UseSelection = ko.observable(false);
    Items = ko.observableArray([]);
    optionsText = '';
    ItemSelectedStateProperty = '';
    itemSelected: any = function () { };
    deleteItem: any = function () { };
    Bao = Bao;
    constructor(params) {
        if (params) {
            // Items
            if (params.items) {
                if (ko.isObservable(params.items)) {
                    this.Items = params.items;
                }
                else {
                    this.Items(params.items);
                }
            }
            // OptionsText
            if (params.optionsText) {
                this.optionsText = ko.unwrap(params.optionsText);
            }
            // OptionsCss
            if (params.ItemSelectedStateProperty) {
                this.ItemSelectedStateProperty = ko.unwrap(params.ItemSelectedStateProperty);
            }
            // Event-itemSelected
            if ($.isFunction(params.itemSelected)) {
                this.itemSelected = params.itemSelected;
            }
            // Event-removeItem
            if ($.isFunction(params.deleteItem)) {
                this.deleteItem = params.deleteItem;
            }
            // Event-removeAll
            if ($.isFunction(params.deleteAll)) {
                this.removeAll = params.deleteAll;
            }
            // ReadOnly
            if (params.ReadOnly != undefined) {
                if (ko.isObservable(params.ReadOnly)) {
                    this.ReadOnly = params.ReadOnly;
                }
                else {
                    this.ReadOnly(params.ReadOnly);
                }
            }
            // Show/Hide Selection
            if (params.UseSelection != undefined) {
                if (ko.isObservable(params.UseSelection)) {
                    this.UseSelection = params.UseSelection;
                }
                else {
                    this.UseSelection(params.UseSelection);
                }
            }
        }
        this.Items.subscribe((value: any) => {
            if (value && value.length) {
                for (var i in value) {
                    if (ko.isObservable(value[i].CssClasses) == false) {
                        value[i].CssClasses = ko.observable("");
                    }
                    value[i].CssClasses(this.GetBadgeItemCssClasses(value[i]));
                }
            }
        });
        // check items...
        var items = this.Items.peek();
        for (var i in items) {
            if (ko.isObservable(items[i].CssClasses) == false) {
                items[i].CssClasses = ko.observable("");
            }
            items[i].CssClasses(this.GetBadgeItemCssClasses(items[i]));
            if (ko.isObservable(items[i].IsSelected) == false) {
                items[i].IsSelected = ko.observable(items[i].IsSelected == true);
            }
        }
    }
    ItemBadges = ko.pureComputed(() => {
        var items = this.Items();
        if (this.ShowAll()) {
            return items;
        }
        else {
            return items.slice(0, 9);
        }
    });
    removeItem(item, event) {
        event.stopPropagation();
        this.deleteItem(item, event);
        let items = this.ItemBadges();
        for (let i in items) {
            items[i].CssClasses(this.GetBadgeItemCssClasses(items[i]));
        }
    }
    setSelection(item, event) {
        this.itemSelected(item, event);
        // get selection-css
        let items = this.ItemBadges();
        for (let i in items) {
            items[i].CssClasses(this.GetBadgeItemCssClasses(items[i]));
        }
    }
    setShowAll() {
        this.ShowAll(!this.ShowAll.peek());
    }
    removeAll(vm, event) {
        var items = this.Items(), itemsCount = items.length, index = 0;
        while (items.length > 0) {
            if (items[index]) {
                this.deleteItem(items[index], event);
                if (items.length === itemsCount) {
                    index++;
                }
            }
            else {
                break;
            }
        }
    }
    /**
     * ko-Binding CSS for badges
     * @param item
     */
    GetBadgeItemCssClasses(item) {
        var cssClasses = [];
        // baoBadge - ursprüngliche selection
        //if (this.UseSelection() === true && item === this.Selection()) {
        //    cssClasses.push("selected");
        //}
        if (this.UseSelection() === true) {
            cssClasses.push("bao-badge-item-selectable");
        }
        if (ko.unwrap(item[this.ItemSelectedStateProperty]) === true) {
            cssClasses.push("alert-success");
        }
        return cssClasses.join(" ");
    }
}
export default {
    viewModel: FinitoBaoBadge2,
    template: template
};